const initializeChatWidget = () => {
    window.helpcrunchSettings = {
        organization: "neuroimprove",
        appId: "a31cdc2b-ef3b-4558-89ed-16998ef6ac70",
    };

    (function (w, d) {
        const hS = w.helpcrunchSettings;
        if (!hS || !hS.organization) {
            return;
        }
        const widgetSrc = "https://embed.helpcrunch.com/sdk.js";
        w.HelpCrunch = function () {
            w.HelpCrunch.q.push(arguments);
        };
        w.HelpCrunch.q = [];
        function r() {
            if (d.querySelector('script[src="' + widgetSrc + '"')) {
                return;
            }
            const s = d.createElement("script");
            s.async = 1;
            s.type = "text/javascript";
            s.src = widgetSrc;
            (d.body || d.head).appendChild(s);
        }
        if (d.readyState === "complete" || hS.loadImmediately) {
            r();
        } else if (w.attachEvent) {
            w.attachEvent("onload", r);
        } else {
            w.addEventListener("load", r, false);
        }
    })(window, document);
};

initializeChatWidget();

const user = {
    custom_data: JSON.parse(localStorage.getItem("utm_params")),
};

HelpCrunch("updateUser", user);
